<template>
    <footer>
        <div class="main-footer">
            <div class="container-xl">
                <div class="row">
                    <div class="col-12 col-md-5 col-lg-6" v-if="currentLang == 'hu'">
                        <div class="newsletter" >
                            <div class="subtitle">{{ lang("iratkozz_fel_hirlevelunkre")}}</div>
                            <validation-observer  v-slot="{ handleSubmit }" tag="div" ref="newsletterForm">
                                <form  @submit.prevent="handleSubmit(formSubmit)" class="newsletter-form" @click="tryFill()">
                                    <div class="row">
                                        <div class="form-group col-12 col-md-6 last_name-row">  
                                            <ValidationProvider rules="required" v-slot="{ errors }">                                      
                                                <input v-model="newsletterForm.last_name" class="form-control" :name="lang('hirlevel_vezeteknev')" id="surname" type="text" :placeholder="lang('vezeteknev')" />
                                                <span class="form__error">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-12 col-md-6 first_name-row"> 
                                            <ValidationProvider rules="required" v-slot="{ errors }">                                        
                                                <input v-model="newsletterForm.first_name" class="form-control" :name="lang('hirlevel_keresztnev')" id="forename" type="text" :placeholder="lang('keresztnev')" />
                                                <span class="form__error">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-12 col-md-6 email-row">    
                                            <ValidationProvider rules="email|required" v-slot="{ errors }">                                    
                                                <input v-model="newsletterForm.email" class="form-control" :name="lang('hirlevel_email')" id="email" type="email" :placeholder="lang('e_mail_cim')" />
                                                <span class="form__error">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="form-group col-12 col-md-6">
                                            <div class="btn--brown-border-wrap" v-if="successSignUp==false">
                                                <button type="submit" class="btn btn--brown-border">{{ lang("feliratkozom")}}<span></span></button>
                                            </div>
                                            <div v-if="successSignUp==true" class="newsletter__success-sign-up-text btn btn--brown-border">
                                                {{ lang('hirlevel_sikeres_feliratkozas') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="custom-control custom-checkbox condition-row">
                                            <ValidationProvider rules="required|acceptConditions" v-slot="{ errors }">
                                                <input  true-value="accepted" false-value="no" v-model="newsletterForm.condition" type="checkbox" class="custom-control-input" id="newsletter_aszf" :name="lang('aszf_checkbox')">
                                                <label class="custom-control-label" for="newsletter_aszf">
                                                    {{ lang('hirlevel_jogi_szoveg')}}
                                                </label>
                                                <span class="form__error">{{ errors[0] }}</span>
                                                <ul v-if="privacyPolicyData.download">
                                                    <li v-for="document in privacyPolicyData.download" :key="document.id">
                                                        <a :href="document.document_id ? doc_url + '/' + document.document_id.path + document.document_id.file_name + '?' + aszfTimeStamp : ''" target="_blank">{{privacyPolicyData.name}}</a>
                                                    </li>
                                                </ul>                                                
                                             </ValidationProvider>
                                        </div>                           
                                    </div>
                                </form>
                            </validation-observer>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4">
                        <nav class="footer-menu">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="subtitle" v-if="footer1Menu.length > 0">{{lang('footer_menu1_title')}}</div>
                                    <ul class="footermenu">
                                        <li v-for="footer1Item in footer1Menu" :key="footer1Item.id">
                                            <a v-if="hasHttp(footer1Item.target_link)" :href="footer1Item.target_link" target="_blank">{{ footer1Item.name }} </a>                         
                                            <router-link v-else :to="{ path: footer1Item.target_link }">{{ footer1Item.name}}</router-link>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-12 col-md-6 footermenu--2-wrap">
                                    <div class="subtitle" v-if="footer2Menu.length > 0">{{lang('footer_menu2_title')}}</div>
                                    <ul class="footermenu ">
                                        <li v-for="footer2Item in footer2Menu" :key="footer2Item.id">
                                            <a v-if="hasHttp(footer2Item.target_link)" :href="footer2Item.target_link" target="_blank">{{ footer2Item.name }} </a>                         
                                            <router-link v-else :to="{ path: footer2Item.target_link }">{{ footer2Item.name}}</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                    <div class="col-12 col-md-3 col-lg-2">
                        <div class="follow-us">
                            <div class="subtitle">{{ lang('footer_kovess_minket')}}</div>
                            <div><a class="btn--social btn btn--facebook" href="https://www.facebook.com/UniverHungary" target="_blank">Facebook</a></div>
                            <div><a class="btn--social btn btn--youtube" href="https://www.youtube.com/user/UniverProduct" target="_blank">Youtube</a></div>
                            <div><a class="btn--social btn btn--instagram" href="https://www.instagram.com/univerhungary/" target="_blank">Instagram</a></div>

                        </div>
                    </div>            
                </div>
            </div>
        </div>
        <div class="sub-footer">
            <div class="container-xl">
                <div class="sub-footer__inner">
                    <img src="@/assets/images/brand/univer-logo.svg" class="img-fluid univer-logo" alt="Univer"  />
                    <p>© {{currentYear}} {{ lang('minden_jog_fenntartva')}}</p>
                    <div class="acg-logo-wrap">
                        <a href="https://www.acg.hu/" target="_blank"><img src="@/assets/images/brand/acg-logo.svg" class="img-fluid" alt="crafted by ACG"  /></a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
/**
 * FORM VALIDATION:
 * use Vee-validatior package
 * required fields: last_name, first_name, email, condition
 * localize() for vee-validatior to set the the error message to different languages
 * success sing up: successSignUp value change true for 3s after false
 */

import { ValidationProvider, ValidationObserver, extend  } from 'vee-validate';
import { required, email  } from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';
// import { localize } from 'vee-validate';
import axios from 'axios'
import $ from "jquery"


//localize messages was setting in the app.vue
// localize({
  
//   en: {
//     messages: {
//       required: '{_field_} required',
//       email: 'Not valid e-mail address',
//       acceptConditions: "Privacy Policy required"
//     }
//   },
//   hu: {
//     messages: {
//       required: '{_field_} megadása kötelező',
//       email: 'Az e-mail mező csak érvényes e-mail címet tartalmazhat.',
//       acceptConditions: "Általános Adatvédelmi Rendelet elfogadása kötelező"
//     }
//   },
// });

setInteractionMode('eager');
extend('email', {
  ...email    
});
extend('required', {
  ...required   
});
extend('acceptConditions', {
    validate(value) {
        return value == "accepted" ? true : false
    }    
})

export default {
    data(){
        return {
            newsletterForm: {
                first_name: '',
                last_name: '',
                email:'',
                condition: ''
            },
            successSignUp: false,
            doc_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME,
            privacyPolicyData: {},
            triedFillForm : false            
        }
    },
    components:{
        ValidationProvider,
        ValidationObserver        
    },
    computed:{
        footer1Menu(){
            return this.$store.getters.getMenuFooter1Menu
        },
        footer2Menu(){
            return this.$store.getters.getMenuFooter2Menu
        },
        aszfTimeStamp(){
            return  Math.floor( Date.now() /1000)
        },
        currentLang(){
            let lang = this.$store.getters.getSelectedLang.name

            if (lang == null) {
                return 'hu'
            } else {
                return this.$store.getters.getSelectedLang.name.toLowerCase()
            }
            
        },
        currentYear(){
            var year = new Date();            
            return year.getFullYear()
        }
    },
    created(){
        this.$store.dispatch("setMenu_footer1Menu");  
        this.$store.dispatch("setMenu_footer2Menu"); 

        this.getPrivacyPolicyData()
                
        // localize(this.currentLangName())        
    },
    methods:{
         formSubmit() {  
            let _this = this

            //axios.post(process.env.VUE_APP_BIFROST_API_URL + '/newsletter', {
            axios.get('/nwl/nwlSubscribe.php'+ '?first_name=' +this.newsletterForm.first_name +"&last_name=" + this.newsletterForm.last_name + "&email="+ this.newsletterForm.email+"&condition=accepted").then(response => {                                
                // console.log('newsletter submit', response)                

                // if (response.data.status == true) {                                        
                //     this.writeSignUpSuccess();                    
                //     _this.setDataLayer('form', 'submit', '')                  
                // }
                
                if (response.data.regSuccess == 1) {
                    if (response.data.message == 'insert') {
                        //new sign up
                        _this.writeSignUpSuccess();                    
                        _this.setDataLayer('form', 'submit', '')   
                    } else if (response.data.message == 'update'){
                        $('.newsletter-form .email-row').append('<div class="form__error-2">'+ this.lang('mar_letezo_email_cim') +'</div>')                    
                    }
                    
                } else {
                    $('.newsletter-form .email-row').append('<div class="form__error-2">'+ this.lang('sikertelen_feliratkozas') +'</div>') 
                }
                        
            })
            .catch(function (error) {
                console.log('newletter error', error)                       

                //write the errors from the server to the user
                // if (error.response) {
                //     // console.log('newletter error', error.response.data.error);

                //     let errorsArray = Object.entries(error.response.data.error);                    
                    
                //     //remove the error-2 divs if there are
                //     if ($('.newsletter-form .form__error-2').length > 0){
                //         $('.newsletter-form .form__error-2').each(function(){
                //             $(this).remove();                            
                //         })
                //     }
                //     //write the errors
                //     for (const [errorName, errorValue] of errorsArray) {                         
                //         $('.newsletter-form .'+ errorName + '-row').append('<div class="form__error-2">'+ errorValue +'</div>')                    
                //     }
                // }
            });
        },
        setDefaultState(){          
            this.newsletterForm.first_name = ''
            this.newsletterForm.last_name = ''
            this.newsletterForm.email = ''
            this.newsletterForm.condition = ''       
            //reset the veeValidate
            this.$refs.newsletterForm.reset()

            $('.newsletter-form .form__error-2').each(function(){
                $(this).remove();                            
            })

        },
        writeSignUpSuccess(){
            let _this = this
            //send an email
            
            // this.sendSuccessEmail(_this.newsletterForm.email, this.newsletterForm.first_name, this.newsletterForm.last_name)
            
            //show the siccess sing up text instead of the sign up button for 3s, after show the button again            

            this.successSignUp = true            
            setTimeout(() => {
                _this.successSignUp = false
                _this.setDefaultState()                
            }, 3000);
        },
        getPrivacyPolicyData(){
            let _this = this                

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information/318?relations=1&where[0][0]=where&where[0][1]=status&where[0][2]=1&relations_params[download][where][0][0]=where&relations_params[download][where][0][1]=language_status&relations_params[download][where][0][2]=1&relations_params[download][order_by][0][0]=sort_order&relations_params[download][order_by][0][1]=asc',{            
                params:{
                    "language_id": _this.$store.getters.getSelectedLang.id
                }
            }).then(response => {                
                if (response.data.status == true ){                    
                    _this.privacyPolicyData = response.data.information[0]
                } else {
                    _this.privacyPolicyData = {}              
                }                                                          
            })
            .catch((err) => {
                console.log(err)
            });
        },
        sendSuccessEmail(userEmail, userFirstName, userLasName){                        
            let langId = this.$store.getters.getSelectedLang.id

            axios.post(process.env.VUE_APP_BIFROST_API_URL + '/emailsender/1/' + langId, {
                to: userEmail,
                data_replace: {
                    first_name: userFirstName,
                    last_name: userLasName
                }                
            })            
            .catch(function (error) {
                console.log(error)
            });
        },
        tryFill(){
            var _this = this;
                                       
            $('form.newsletter-form').find('input[type=text], input[type=checkbox]').each(function(){
                $(this).change(function(){                        
                    if ( _this.triedFillForm != true) {                                                 
                        _this.setDataLayer('form', 'start', '')
                        _this.triedFillForm = true;
                    }                                                                                             
                })
            })                        
        },
    }
}
</script>